export const getFacilityKpiIndicators = (documentId, state) => {
  const facilityKpiIndicators = state.facilities.facilityKpiIndicators[documentId]
    ? state.facilities.facilityKpiIndicators[documentId]
    : [];

  const loaded = facilityKpiIndicators && facilityKpiIndicators.loaded ? facilityKpiIndicators.loaded : false;
  const loading = facilityKpiIndicators && facilityKpiIndicators.loading ? facilityKpiIndicators.loading : false;
  const kpiIndicators = loaded ? facilityKpiIndicators.kpiIndicators : [];
  return { kpiIndicators, loading, loaded };
};
